import { useState, useCallback } from 'react'

const usePagination = (initialRows = 10) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(initialRows)
  const handleChangePage = useCallback((event, newPage) => setPage(newPage), [])
  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }, [])
  return { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }
}

export default usePagination
